require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconSearch.tsx
var IconSearch_exports = {};
__export(IconSearch_exports, {
  default: () => IconSearch_default
});
module.exports = __toCommonJS(IconSearch_exports);

// src/assets/monochrome/search.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgSearch = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7439 9.0625C13.7439 11.6513 11.6464 13.75 9.05893 13.75C6.4715 13.75 4.37398 11.6513 4.37398 9.0625C4.37398 6.47366 6.4715 4.375 9.05893 4.375C11.6464 4.375 13.7439 6.47366 13.7439 9.0625ZM12.9913 14.3152C11.8956 15.1377 10.5342 15.625 9.05893 15.625C5.43653 15.625 2.5 12.6869 2.5 9.0625C2.5 5.43813 5.43653 2.5 9.05893 2.5C12.6813 2.5 15.6179 5.43813 15.6179 9.0625C15.6179 10.5346 15.1334 11.8935 14.3153 12.9883L17.225 15.8996C17.591 16.2657 17.591 16.8593 17.225 17.2254C16.8591 17.5915 16.2659 17.5915 15.8999 17.2254L12.9913 14.3152Z", fill: "#818898" }) });
var search_default = SvgSearch;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconSearch.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconSearch = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(search_default, {}) });
};
IconSearch.displayName = "IconSearch";
var IconSearch_default = IconSearch;
